<template>
    <div class="content-wrapper">
      <div id="hero-wrapper" class="content content-wide">
        <div id="hero">
          <div id="hero-content">
            <h2>Planlæg</h2>
            <h1>Vognturen.</h1>
            <p>Få maksimalt ud af studenterturen med en optimeret rute fra Tripply. Spar timer og penge og få mere tid til dét, der betyder noget.</p>

            <AppButton @click="createRoute()" size="large">Opret rute</AppButton>
          </div>
          <!--<div id="hero-teaser" class="card">
            <iframe width="400" height="200" src="https://www.youtube.com/embed/l3_9bn73jCU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>-->
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import { store } from '@/store'

export default defineComponent({
  name: 'AppHero',
  components: { },
  setup() {
    const state = reactive({
      frame: 0,
      frames: 3
    })

    function createRoute() {
      store.user.createRoute()
    }

    window.setInterval(() => {
      state.frame = state.frame < state.frames - 1 ? state.frame + 1 : 0
    }, 5000)

    return { state, createRoute }
  }
})
</script>

<style lang="scss">
  #hero-wrapper {
    background: var(--color-primary);
    color: var(--color-on-primary);
    border-radius: 3rem;
    padding: 0 3rem;

    .content {
      padding: 0;
    }

    #hero {
      border-radius: 3rem;
      padding: 3rem 0;
      display: flex;
      justify-content: center;

      h1 {
        font-size: 5rem;
        transition: color .2s;
        font-weight: 700;
        margin-bottom: 2rem;
      }
      h2 {
        font-size: 3rem;
        margin: 0;
        margin-bottom: -.4em;
      }
      h3 {
        font-size: 1.25rem;
      }
      p {
        font-size: 1.25rem;
        max-width: 480px;
      }
      button {
        color: white;
        background: var(--color-secondary);
        margin-top: 2rem;
      }
      &-content {
        width: 100%;
      }
      &-teaser iframe {
        width: 100%;
        height: 100%;
      }
    }

    &.frame-0 {
      #hero h1 { color: var(--color-primary) }
      button { background-color: var(--color-primary) }
      #wave { fill: var(--color-primary) }
      #hero { background: #0066ff10; }
    }
    &.frame-1 {
      #hero h1 { color: var(--color-warning) }
      button { background-color: var(--color-warning) }
      #wave { fill: var(--color-warning) }
      #hero { background: #ff990010; }
    }
    &.frame-2 {
      #hero h1 { color: var(--color-success) }
      button { background-color: var(--color-success) }
      #wave { fill: var(--color-success) }
      #hero { background: #00d28410; }
    }
  }

  @media only screen and (max-width: 1400px) {
    #hero-teaser iframe {
      width: 325px;
      height: 164px;
    }
  }
  @media only screen and (max-width: 1000px) {
    #hero {
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
    }
  }
  @media only screen and (max-width: 1500px) {
    #hero-wrapper {
      padding-left: 2.5rem;
      padding-right: 2.5rem;
      margin-right: 0;
      margin-left: 0; 
    }
  }
  @media only screen and (max-width: 600px) {
    #hero-wrapper {
      padding-top: 1rem;
      padding-left: 0;
      padding-right: 0;
      margin-right: 0;
      margin-left: 0; 
      border-radius: 2rem;
      #hero {
        border-radius: 2rem;
        padding: 2rem;
        h1 {
          font-size: 3rem;
        }
        h2 {
          font-size: 2rem;
        }
      }
    }
  }

</style>